import { FunctionComponent, memo, useState } from "react";
import { IProps } from "./agnet-writing-issues-table.types";
import WritingIssuesFrequencyTable from "../../../components-for/writing-issues/writing-issues-frequency-table";
import WritingIssuesTable from "../../../components-for/writing-issues/writing-issues-table";
import { useQueryParameters } from "@edgetier/client-components";
import { IWritingIssuesCount, WritingIssueType } from "@edgetier/watchtower-types";
import "./agent-writing-issues-table.scss";

/**
 * Show the most common writing issues for a single agent.
 * @returns Two tables. One showing the frequency of different writing issues and another showing individual issues.
 */
const AgentWritingIssuesTable: FunctionComponent<IProps> = () => {
    const { reviewAgentId } = useQueryParameters({ reviewAgentId: String });
    const [selectedIssueCount, setSelectedIssueCount] = useState<{
        issue?: string;
        writingIssueType?: WritingIssueType;
    }>({
        issue: undefined,
        writingIssueType: undefined,
    });

    /**
     * Set the issue and issue type that was clicked.
     * @param writingIssueCount The writing issue count that was clicked.
     */
    const onRowClick = (writingIssueCount: IWritingIssuesCount<[WritingIssueType, string]>) => {
        const [writingIssueType, issue] = writingIssueCount.groups;
        setSelectedIssueCount(({ issue: previousIssue, writingIssueType: previousWritingIssueType }) => {
            if (previousIssue === issue && previousWritingIssueType === writingIssueType) {
                return { issue: undefined, writingIssueType: undefined };
            }
            return { issue, writingIssueType };
        });
    };

    return (
        <div className="agent-writing-issues-table">
            <div>
                <WritingIssuesFrequencyTable parameters={{ agentId: reviewAgentId }} onRowClick={onRowClick} />
            </div>
            <div>
                <WritingIssuesTable
                    parameters={{ agentId: reviewAgentId, ...selectedIssueCount }}
                    requestsEnabled={
                        typeof selectedIssueCount.issue !== "undefined" &&
                        typeof selectedIssueCount.writingIssueType !== "undefined"
                    }
                />
            </div>
        </div>
    );
};

export default memo(AgentWritingIssuesTable);
